import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowDown } from 'lucide-react';
import { PointerGlow } from './motion';
import BinaryMap from './BinaryMap';
import { OFFICES } from './Globe';

const useClock = () => {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => { const t = setInterval(() => setNow(new Date()), 15000); return () => clearInterval(t); }, []);
  return now;
};

const HeroSection = () => {
  const now = useClock();
  return (
    <section className="relative min-h-screen overflow-hidden flex flex-col">
      <PointerGlow />
      <BinaryMap className="absolute inset-0 w-full h-full" />
      {/* keeps the headline legible over the digits */}
      <div className="absolute inset-0 pointer-events-none" style={{ background: 'linear-gradient(90deg, var(--ink) 0%, color-mix(in srgb, var(--ink) 80%, transparent) 22%, transparent 48%)' }} />
      <div className="absolute inset-x-0 bottom-0 h-40 pointer-events-none" style={{ background: 'linear-gradient(0deg, var(--ink), transparent)' }} />

      <div className="relative flex-1 flex items-center max-w-7xl w-full mx-auto px-6 pt-32 pb-16 pointer-events-none">
        <div className="pointer-events-auto">
          <p className="font-mono-label flex items-center gap-3 text-[var(--muted)] mb-6 reveal in">
            <span className="pulse-dot" /> 01001001 01010100 <span className="text-[var(--red)]">// IT, encoded</span>
          </p>
          <h1 className="font-display text-[3.6rem] sm:text-8xl lg:text-[6.5rem] leading-[0.9] max-w-4xl">
            <span className="line-mask"><span>Secure systems.</span></span>
            <span className="line-mask"><span style={{ '--d': '150ms' }}><em className="text-[var(--red)]">Borderless</em></span></span>
            <span className="line-mask"><span style={{ '--d': '300ms' }}>business.</span></span>
          </h1>
          <p className="mt-7 max-w-md text-lg text-[var(--muted)] leading-relaxed reveal in" style={{ '--d': '700ms' }}>
            Cybersecurity, cloud and infrastructure for the banks, enterprises and governments that can’t afford downtime.
          </p>
          <div className="mt-8 flex flex-wrap gap-4 reveal in" style={{ '--d': '850ms' }}>
            <Link to="/contact" className="btn btn-primary">Start a project</Link>
            <Link to="/services" className="btn btn-ghost">Explore services</Link>
          </div>
        </div>
      </div>

      <div className="relative border-t border-[var(--line)] bg-[var(--glass)] backdrop-blur-md">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-wrap items-center gap-x-10 gap-y-3">
          {OFFICES.map((o) => (
            <p key={o.city} className="font-mono-label flex items-center gap-2 text-[var(--muted)]">
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
              <span className="text-[var(--paper)]">{o.city}</span>
              {now.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', timeZone: o.tz })}
            </p>
          ))}
          <a href="#statement" className="font-mono-label ml-auto hidden sm:flex items-center gap-2 text-[var(--muted)] hover:text-[var(--paper)] transition-colors">Scroll <ArrowDown className="w-3.5 h-3.5 animate-bounce" /></a>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
